/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
 

export enum cabinTypeEnum {
  BALCONY = 'Balcony',
  JUNIOR_SUITE = 'JuniorSuite',
  INTERIOR = 'Interior',
  VERANDA = 'Veranda',
  SUITE = 'Suite',
  OUTSIDE = 'Outside',
  FAMILY = 'Family',
  SINGLE = 'Single',
}
